// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c947b82","667":"680f5406","977":"3b008b52"}[chunkId] + ".chunk.js";
};